import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

export const makeStore = (initialState, options) => {
    return createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk)));
};
